export default {
    contactUs: 'Kontaktujte nás',
    contact: 'Kontakt',
    blogTitle: 'Budujeme budúcnosť v starostlivosti o úsmev',
    blogDescription:
        'Vyvíjame produkty, ktoré sú založené na viere, že bielenie zubov môže byť účinné a bezpečné',
    blogButton: 'Zobraziť všetko',
    allAboutHelloCoco: 'Všetko o hello coco',
    aboutUs: 'O nás',
    reviews: 'Recenzie',
    reviewsLink: '/recenzie/',
    cocoEmail: 'kontakt@hellococo.sk',
    termsAndConditions: 'Obchodné podmienky',
    termsAndConditionsLink: '/obchodne-podmienky/',
    privacyPolicy: 'Ochrana súkromia',
    privacyPolicyLink: '/ochrana-sukromia/',
    purchase: 'Nákup',

    emptyCartText: 'Košík čaká na svoje prvé objavy - pozrite sa na našu ponuku!',
    startShopping: 'Začať nakupovať',

    orderSummary: 'Rekapitulácia objednávky',
    shippingAndPayment: 'Doprava a platba',
    discountCoupon: 'Zľavový kupón',
    applyDiscount: 'Uplatniť',
    giftsHeading: 'Vyberte si darček ZADARMO',

    orderInfo: 'Informácie o vás',
    orderNumber: 'Číslo objednávky',

    'header.others': 'Ostatné',
    'header.categories': 'Kategórie',
    'header.followUs': 'Sledujte nás',

    'emptyCart.title': 'Váš košík je prázdny',
    'emptyCart.backToShop': 'Zpět do obchodu',

    show_all: 'Zobraziť všetko',

    aboutUsLink: '/o-nas/',
    contactUsLink: '/kontakt/',
    'instagram.title': 'Odborníci v starostlivosti o úsmev @hellococoskcz',
    'instagram.url': 'https://www.instagram.com/hellococo_skcz/',

    'facebook.url': 'https://www.facebook.com/hellococo.skcz/',
}
